var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video youtube-frame" },
    [
      !_vm.isPlaing
        ? _c("div", {
            staticClass: "playpause",
            attrs: { "data-string": _vm.titleString },
            on: { click: _vm.playVideo }
          })
        : _vm._e(),
      !_vm.isPlaing ? _vm._t("preview") : _vm._e(),
      _vm.mp4Video
        ? _c(
            "video",
            {
              ref: "video",
              staticClass: "video__video youtube-frame",
              attrs: {
                loop: "false",
                autoplay: "autoplay",
                controls: "controls"
              }
            },
            [_c("source", { attrs: { type: "video/mp4", src: _vm.urlVideo } })]
          )
        : _vm._e(),
      !_vm.mp4Video && _vm.isPlaing
        ? _c("iframe", {
            staticClass: "video__iframe youtube-frame",
            attrs: {
              src: _vm.videoEmbed(_vm.videoUrl),
              frameborder: "0",
              allow: "autoplay; encrypted-media",
              allowfullscreen: "allowfullscreen"
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7fe1fec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7fe1fec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/UiPreview.vue
// module id = 81
// module chunks = 0